export enum ItemType {

  Item = 1,
  Module = 5

}
